import { render, staticRenderFns } from "./courseotherview.vue?vue&type=template&id=8901f912"
import script from "./courseotherview.vue?vue&type=script&lang=js"
export * from "./courseotherview.vue?vue&type=script&lang=js"
import style0 from "./courseotherview.vue?vue&type=style&index=0&id=8901f912&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports